import src from "IMAGE";
export default { src, width: 568, height: 228, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
